import type {
  AchAccountType,
  PaymentMethod,
  PaymentMethodSlot,
} from "../types";

const ACCOUNT_TYPE_LABELS: Record<AchAccountType, string> = {
  checking: "Checking",
  savings: "Savings",
};

export const ACCOUNT_TYPE_OPTIONS = Object.entries(ACCOUNT_TYPE_LABELS).map(
  ([id, label]) => ({ id, label }),
);

export function maskedNumber(method: PaymentMethod): string {
  return method.type === "card"
    ? `•••• •••• •••• ${method.last4}`
    : `•••• ${method.last4}`;
}

export function formatExpiry(month: number, year: number): string {
  return `${String(month).padStart(2, "0")}/${String(year).slice(-2)}`;
}

export function paymentMethodDetails(method: PaymentMethod): string {
  return method.type === "card"
    ? `Expires ${formatExpiry(method.expiryMonth, method.expiryYear)}`
    : `ACH · ${method.bankName}`;
}

export function paymentMethodSummary(method: PaymentMethod): string {
  return method.type === "card"
    ? `${capitalize(method.brand)} •••• ${method.last4} · ${paymentMethodDetails(method)}`
    : `${method.bankName} ${ACCOUNT_TYPE_LABELS[method.accountType].toLowerCase()} •••• ${method.last4}`;
}

export function slotLabel(slot: PaymentMethodSlot): string {
  return slot.kind === "default"
    ? "Default method"
    : `Backup method ${slot.index + 1}`;
}

export function slotDescription(slot: PaymentMethodSlot): string {
  if (slot.kind === "default") return "Used for all recurring charges";

  return slot.index === 0
    ? "Used automatically if primary fails"
    : "Used automatically if secondary fails";
}

function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
